import {  AccidentClaimsEffects } from './accident-participants.effect';

export const AccidentEffects = [
  AccidentClaimsEffects
]

export * from './accident-participants.effect';
